import React from "react";
import ReactDOM from "react-dom";
import { ReactComponent as CloseIcon } from "assets/svgs/close-modal.svg";

const Modal = ({ children, isOpen, closeModal, modalContentClass }) => {
  return (
    <>
      {ReactDOM.createPortal(
        <div
          className={`fixed top-0 left-0 h-full w-full bg-black bg-opacity-70 z-[250] ${
            isOpen ? "block" : "hidden"
          }`}
        />,
        document.body
      )}
      {ReactDOM.createPortal(
        <div
          style={{ transform: "translate(-50%, -50%)" }}
          className={`fixed left-1/2 top-1/2 bg-white shadow-secondary-field border border-solid border-black rounded-[43px] z-[260] modal-content ${modalContentClass} ${
            isOpen ? "block" : "hidden"
          }`}
        >
          <div className="relative w-full">
            <div className="py-10 px-6 lg:px-14 w-full max-h-[82vh] overflow-y-auto">{children}</div>
            <button
              className="absolute top-3 right-5 w-8 h-8 flex items-center justify-center rounded-full bg-black hover:bg-gray-800 transition-colors"
              onClick={closeModal}
            >
              <CloseIcon style={{ filter: "invert(1)" }} />
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default Modal;